import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/rauza-icon.png';
const _withScopeId = n => (_pushScopeId("data-v-f1d88688"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-header"
};
const _hoisted_2 = {
  class: "sc-offset flex-vertical sc-header-inner"
};
const _hoisted_3 = {
  class: "flex-divider flex-vertical"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sc-logo",
  src: _imports_0
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sc-logo-label"
}, "Рауза-АДЕ Центр жалоб и предложений", -1));
const _hoisted_6 = {
  class: "sc-header-menu"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0,
  class: "sc-mobile-menu"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sc-mobile-label"
}, "Рауза-АДЕ Центр жалоб и предложений", -1));
const _hoisted_10 = {
  class: "sc-mobile-header"
};
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Menu = _resolveComponent("Menu");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_divider = _resolveComponent("el-divider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, {
    class: "sc-mobile-menu-toggler",
    onClick: _cache[0] || (_cache[0] = $event => {
      $data.ui_events.mobileMenu.active = !$data.ui_events.mobileMenu.active;
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_Menu)]),
    _: 1
  }), _hoisted_4, _createVNode(_component_router_link, {
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ui_data.menu, (i, ind) => {
    return _openBlock(), _createElementBlock("div", {
      class: "sc-header-menu-item",
      key: ind,
      onClick: $event => i.action()
    }, _toDisplayString(i.name), 9, _hoisted_7);
  }), 128))])]), _createVNode(_component_el_button, {
    onClick: $options.routerNewTicket
  }, {
    default: _withCtx(() => [_createTextVNode("Создать тикет")]),
    _: 1
  }, 8, ["onClick"])])]), _createVNode(_component_el_divider), $data.ui_events.mobileMenu.active ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ui_data.menu, (i, ind) => {
    return _openBlock(), _createElementBlock("div", {
      class: "sc-mobile-header-item",
      key: ind,
      onClick: $event => {
        i.action();
        $data.ui_events.mobileMenu.active = false;
      }
    }, _toDisplayString(i.name), 9, _hoisted_11);
  }), 128))])])) : _createCommentVNode("", true)], 64);
}